import React from 'react';

import {GenericHookPaginatedList} from 'app/components/general/lists/GenericHookPaginatedList';
import {
  convertLocationParamsToFetchParams,
  useProcesses,
} from 'app/process/api';
import {CompactProcessItem} from 'app/process/components/CompactProcessItem';
import {useUserDetails} from 'app/user/api';
import {gt} from 'app/utils/i18n';

import type {
  ProcessDashboardFetchParamsType,
  ProcessLocationParamsType,
} from 'app/process/types';
import type {WithRouterProps} from 'react-router';
import type {ProcessSerializedType} from 'sweet-types';
export const ProcessList = (routerProps: WithRouterProps) => {
  const {data: user} = useUserDetails({id: routerProps.params.userid});

  return (
    <GenericHookPaginatedList<
      ProcessSerializedType,
      ProcessLocationParamsType,
      ProcessDashboardFetchParamsType
    >
      {...routerProps}
      useDataHook={useProcesses}
      hookParams={{
        visible_to_user: routerProps.params.userid,
      }}
      convertParamsFunc={convertLocationParamsToFetchParams}
      renderItem={(process) => (
        <CompactProcessItem
          object={process}
          key={process.id}
          actionsGetter={() => []}
        />
      )}
      messages={{
        notFound: ({NoResultsMessage}) => (
          <NoResultsMessage
            head={
              user?.is_guest_until != null
                ? gt('Guests have no access to processes')
                : gt("This member doesn't have access to any process")
            }
            icon="fas fa-user-clock"
          />
        ),
      }}
    />
  );
};
